export const MMPITest = ({
  _patient,
  _cb,
}: {
  _patient?: string;
  _cb?: () => void;
}) => {
  return <h1>Coming Soon</h1>;
};
